<template>
    <v-container>

        <v-flex>
            <v-row>
                <h1 class="page-title">Registration</h1>
                <v-spacer class="line"></v-spacer>
                <hr>
                <span class="auth-type-question">Already registered?</span>
                <v-btn depressed
                       color="primary"
                       to="/login"
                >
                    <v-icon left>mdi-account</v-icon>
                    Log In
                </v-btn>
            </v-row>
        </v-flex>

        <v-card>
            <v-container>

                <v-form ref="form"
                        v-model="valid"
                        validation>
                    <v-layout row>
                        <v-flex xs12>
                            <v-card-text>
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        name="First Name"
                                        label="First Name"
                                        type="text"
                                        v-model="firstName"
                                        :rules="nameRules"
                                ></v-text-field>
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        name="Last Name"
                                        label="Last Name"
                                        type="text"
                                        v-model="lastName"
                                        :rules="lastNameRules"
                                ></v-text-field>
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        name="email"
                                        label="Email"
                                        type="email"
                                        v-model="email"
                                        :rules="emailRules"
                                ></v-text-field>
                                <v-text-field
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="showPassword ? 'text' : 'password'"
                                        @click:append="showPassword = !showPassword"
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        name="password"
                                        label="Password"
                                        v-model="password"
                                        :rules="passwordRules"
                                        :counter="12"
                                ></v-text-field>
                                <v-text-field
                                        :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="showConfirmPassword ? 'text' : 'password'"
                                        @click:append="showConfirmPassword = !showConfirmPassword"
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        name="confirm-password"
                                        label="Confirm Password"
                                        v-model="confirmPassword"
                                        :rules="confirmPasswordRules"
                                        :counter="12"
                                ></v-text-field>
                            </v-card-text>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs12>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                        depressed
                                        class="primary"
                                        @click="onSubmit"
                                        :loading="localLoading"
                                        :disabled="!valid || localLoading"

                                >
                                    <v-icon left>mdi-check</v-icon>
                                    Register
                                </v-btn>
                                <v-btn
                                        depressed
                                        class="warning"
                                        @click="onCancel"
                                        :loading="localLoading"
                                        :disabled="localLoading"
                                >
                                    <v-icon left>mdi-cancel</v-icon>
                                    Cancel
                                </v-btn>
                            </v-card-actions>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Registration",
        data() {
            return {
                showPassword: false,
                showConfirmPassword: false,
                email: '',
                password: '',
                confirmPassword: '',
                firstName: '',
                lastName: '',
                valid: false,
                localLoading: false,
                nameRules: [
                    v => !!v || 'Please enter your name',
                ],
                lastNameRules: [
                    v => !!v || 'Please enter your last name',
                ],
                emailRules: [
                    v => !!v || 'Please enter your e-mail',
                    v => /.+@.+/.test(v) || 'Must be valid e-mail'
                ],
                passwordRules: [
                    v => !!v || 'Please enter password',
                    v => (v && v.length >= 6) || 'Min 6 symbols'
                ],
                confirmPasswordRules: [
                    v => !!v || 'Please confirm your password',
                    v => v === this.password || 'Passwords do not match'
                ]
            }
        },
        created() {

            if (this.$route.query['loginError']) {
                this.$store.dispatch('setError', 'Please log in to access this page')
            }
            if (localStorage.getItem("user")) {
                // let user = JSON.parse(localStorage.getItem("user"));
                // this.$store.commit('setUser',user);
                this.$router.push('/newsfeed');
            }
        },
        methods: {
            onCancel() {
                this.email = ''
                this.password = ''
                this.confirmPassword = ''
                this.firstName = ''
                this.lastName = ''
            },
            onSubmit() {
                if (this.$refs.form.validate()) {
                    this.localLoading = true
                    const user = {
                        firstName: this.firstName,
                        lastName: this.lastName,
                        email: this.email,
                        password: this.password
                    }

                    console.log(`${this.appConfig.app_url}/api/register`);
                    console.log(`${this.appConfig.app_url}`);
//                    return false;
                    axios.post(`${this.appConfig.app_url}/api/register`, user)
                        .then(res => {
                            let result = res.data.user;
                            this.$store.dispatch('registerUser', result);

                            let newUser = {
                                id: result.id,
                                firstName: result.first_name,
                                lastName: result.last_name,
                                email: result.email,
                                restaurantsWorksFor: [],
                                access_token: res.data.access_token
                            };
                            return newUser;

                        }).then(user => {
                        this.$store.commit('setUser', user);
                        localStorage.setItem("user", JSON.stringify(user));

                        return '/newsfeed';
                    })
                        .then(route => {
                            this.$router.push(route);
                        })
                        .catch(error => {
                            let errors = error.response.data.error;
                            this.$store.dispatch('setError', errors[Object.keys(errors)[0]][0]);
                            this.password = '';
                            this.confirmPassword = '';
                        })
                        .finally(() => {
                            this.localLoading = false;
                        });

                }
            }
        }
    }
</script>

<style scoped>

</style>